/* eslint-disable no-undef */

import Vue from 'vue';
import App from './App';
import store from './store';
import router from './router';
import Sortable from 'sortablejs';
import ApiPlugin from './plugins/ApiPlugin';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VueGtm from 'vue-gtm';
import 'whatwg-fetch';
import i18n from './languages';
import { LOAD_STORED_AUTH } from './store/types';
import vSelect from 'vue-select';

import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect);

Vue.config.productionTip = false;

const nodeEnv = process.env.NODE_ENV;

if (nodeEnv === 'production') {
    console.log = () => {};
    console.warn = () => {};
    console.debug = () => {};
    console.error = () => {};
}

Vue.directive('sortable', {
    inserted: function(el, binding) {
        new Sortable(el, binding.value || {});
    },
});

Object.defineProperty(Vue.prototype, '$eventHub', {
    get() {
        return this.$root.eventHub;
    },
});

//Eventhub for simple communications between components
var eventHub = new Vue({});

// Override the config with the one from /public/config

const configFileName = nodeEnv === 'production' ? 'config.json' : nodeEnv + '.json';

fetch('/config/' + configFileName, null)
    .then(configResponse => {
        configResponse.json().then(config => {
            Vue.prototype.$config = config;
            Vue.prototype.$config.debug = nodeEnv === 'development';

            configureAPI(config);
            connectRaven(config);
            connectGTM(config);
            connectHubspot(config);

            new Vue({
                el: '#app',
                store,
                router,
                i18n,
                render: h => h(App),
                data: {
                    eventHub: eventHub, // Here we bind our event bus to our $root Vue model.
                },
            });
        });
    })
    .catch(() => console.log('No configuration file provided.'));

/**
 * API Plugin configuration
 */
function configureAPI(config) {
    store.commit(LOAD_STORED_AUTH);

    Vue.use(ApiPlugin, {
        baseUrl: config.api.url,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.auth.token,
        },
        vueRouter: router,
    });
}

/**
 * Error reporting configuration: Sentry + Raven
 */
function connectRaven(config) {
    if (!config.debug && config.errorTracking && config.errorTracking.enabled) {
        Raven.config(config.errorTracking.url)
            .addPlugin(RavenVue, Vue)
            .install();
    }
}

/**
 * Google Tag Manager configuration
 */
function connectGTM(config) {
    if (config.gtm && config.gtm.enabled) {
        Vue.use(VueGtm, {
            id: config.gtm.id,
            enabled: true,
            vueRouter: router,
        });
        console.log('[ Analytics ]', 'Connected Google Tags Manager', config.gtm.id);
    }
}

/**
 * Hubspot Analytics configuration
 */
function connectHubspot(config) {
    if (config.hubspot && config.hubspot.enabled) {
        // const script = document.createElement('script');
        // script.src = '//js-eu1.hs-scripts.com/' + config.hubspot.id + '.js';
        // script.async = true;
        // script.defer = true;
        // script.id = 'hs-script-loader';
        // script.type = 'text/javascript';
        // document.body.appendChild(script);
        // console.log('[ Analytics ]', 'Connected Hubspot Analytics', config.hubspot.id);
    }
}
